import { taxiTypes } from "redux/reducers/taxis/taxiTypes"
import {
  PROYECT,
  api_get,
} from "services/api"
import { setSnackbar, startRequestComp, stopRequestComp } from "../search/searchActions"
import { addLabelArray } from "helpers/addLabelArray"
import { api_post } from "services/api"
import { extractIDs } from "helpers/extractIDs"
import { api_put } from "services/api"

const mainUrl = `${process.env.REACT_APP_URL}${PROYECT}`

const {
  GET_TAXIS,

  SELECT_TAXI_COMPANY,
  SELECT_TAXI_STATIONS,

  SET_CUSTOMERS_OPT,
  SET_CUSTOMER_OPT,
  SET_CUSTOMER_STATIONS_OPT_SELECTED,
  SET_CUSTOMER_UNITS_OPT_SELECTED,

  TAXI_REGISTER_NEW,
  SET_TAXI_CUSTOMER_INFO,
  TAXI_EDIT,
  UPDATE_STATIONS_UNITS_TAXI,

  SET_CONFIG_PAGE_TAXIS,
  SET_CONFIG_PAGE_TAXIS_COUNT,
  SET_CONFIG_SORTED_TAXIS,
  SET_CONFIG_FILTERED_TAXIS,
  TAXI_RESTORE_MODAL
} = taxiTypes
const taxisUrl = `${mainUrl}/taxi`

export const getTaxis = () => {

  return async (dispatch) => {
    dispatch(startRequestComp('taxiLoading'))

    await api_get(taxisUrl).then(resp => {
      dispatch({ type: GET_TAXIS, payload: resp })
      dispatch(stopRequestComp('taxiLoading'))
    }).catch(err => {
      dispatch(setSnackbar(err))
      dispatch(stopRequestComp('taxiLoading'))
    })
  }
}

export const selectTaxiCompany = (company) => {
  return {
    type: SELECT_TAXI_COMPANY,
    payload: company
  }
}

export const selectTaxiStations = (stations) => {
  return {
    type: SELECT_TAXI_STATIONS,
    payload: stations
  }
}

export const getCustomersOpt = (customer, signal) => {
  const url = `${mainUrl}/customers?filter=${customer}`;
  return async (dispatch) => {
    dispatch(startRequestComp('loadingTaxiAccounts'));
    try {
      const resp = await api_get(url, { signal });
      if (resp.length === 0) {
        dispatch(setSnackbar('No se encontraron clientes.', 'warning'));
        return;
      }
      const customersLabel = addLabelArray(resp, 'name')
      dispatch({
        type: SET_CUSTOMERS_OPT,
        payload: customersLabel,
      });
    } catch (err) {
      if (err.name !== 'AbortError') {
        dispatch(setSnackbar(err.message, 'error'));
      }
    } finally {
      dispatch(stopRequestComp('loadingTaxiAccounts'));
    }
  };
};

export const handleSelectTaxiCustomer = (customer, stationsOpt, units) => {
  return {
    type: SET_CUSTOMER_OPT,
    payload: {
      customer: customer,
      stations: stationsOpt,
      units: units
    }
  }
}

export const handleCustomerStationsSelected = (stations, units) => {
  return {
    type: SET_CUSTOMER_STATIONS_OPT_SELECTED,
    payload: { stations: stations, units: units }
  }
}

export const handleCustomerUnitsSelected = (units) => {
  return {
    type: SET_CUSTOMER_UNITS_OPT_SELECTED,
    payload: units
  }
}


export const restoreTaxiModal = () => {
  return { type: TAXI_RESTORE_MODAL }
}

export const registerNewTaxi = (form, close = null) => {
  const newForm = [form]
  return async dispatch => {
    dispatch(startRequestComp('loadingTaxiCustomer'));
    await api_post(taxisUrl, newForm).then(resp => {
      dispatch({
        type: TAXI_REGISTER_NEW,
        payload: resp[0]
      })
      dispatch(stopRequestComp('loadingTaxiCustomer'));
      dispatch(setSnackbar("Creado con éxito", "success"))
      close && close()
    }).catch(err => {
      dispatch(stopRequestComp('loadingTaxiCustomer'));
      dispatch(setSnackbar(err))
    })
  }
}

export const getCustomerTaxiInfo = (taxi, stations, units, companies, allStations, allUnits, open = null, setData) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/customers/${taxi.idCustomer}`
  return async dispatch => {
    dispatch(startRequestComp('loadingTaxiCustomer'));
    await api_get(url).then(resp => {
      const labelResp = addLabelArray(resp, 'name')
      const customer = labelResp[0]
      const stationsIDs = extractIDs(customer.accounts, 'idStation', true)
      const stationsOpt = stationsIDs.map(id => {
        const station = allStations[id]
        return {
          ...station,
          label2: `${companies[station.id_company].name} - ${station.label}`
        }
      })
      // const unitsOpt =
      const newPayload = {
        customer: customer,
        stations: stations,
        units: units,
        taxi: taxi
      }
      setData(prev => ({...prev, ...newPayload}))
      // dispatch({
      //   type: SET_TAXI_CUSTOMER_INFO,
      //   payload: newPayload
      // })
      dispatch(stopRequestComp('loadingTaxiCustomer'));
      open && open()
    }).catch(err => {
      dispatch(setSnackbar(err))
      dispatch(stopRequestComp('loadingTaxiCustomer'));
    })
  }
}

export const editTaxiCustomer = (form, close = null) => {
  return async dispatch => {
    dispatch(startRequestComp('loadingTaxiCustomer'));
    await api_put(taxisUrl, form).then(resp => {
      dispatch({
        type: TAXI_EDIT,
        payload: resp
      })
      dispatch(stopRequestComp('loadingTaxiCustomer'));
      dispatch(setSnackbar("Edición éxitosa", "success"))
      close && close()
    }).catch(err => {
      dispatch(stopRequestComp('loadingTaxiCustomer'));
      dispatch(setSnackbar(err))
    })
  }
}

export const updateStationsAndUnitsOpts = (available, stations, units) => {
  return {
    type: UPDATE_STATIONS_UNITS_TAXI,
    payload: {
      stations: stations,
      units: units,
      available: available
    }
  }
}
export const configPageTaxis = (page) => {
  return { type: SET_CONFIG_PAGE_TAXIS, payload: page }
}


export const configPageTaxisSize = (page) => {
  return {
    type: SET_CONFIG_PAGE_TAXIS_COUNT,
    payload: page
  }
}
export const configFilterTaxis = (filter) => {
  return { type: SET_CONFIG_FILTERED_TAXIS, payload: filter }
}


export const configSortedTaxis = (sorted) => {
  return { type: SET_CONFIG_SORTED_TAXIS, payload: sorted }
}
